var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-button"},[_c('div',{staticClass:"radio-button__circle",class:{ 'radio-button__circle--checked': _vm.checked },on:{"click":_vm.change}}),_c('div',{staticClass:"radio-button__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }